import axios from 'axios';
import config from '../config'
import qs from 'qs';
import { getNow, randomString } from '../utils/tool'
import sa from '../utils/shence'

const zaApi = config.API_ROOT;
const cmsApi = config.API_CMS;

// axios.defaults.baseURL = 'https://api.example.com';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 添加请求拦截器
axios.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
    // console.log(response,'返回数据成功')
    return response;
}, function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default {
    axios: (data) => {
        let method = data.method || 'post';
        //公共参数
        var p = Object.assign({}, {
            'partnerNo': 'NYDDXJD',
            'reqNo': randomString(20),
            'reqDate': getNow(),
            'apiVersion': '1.0.0',
            'versionCode': '230',
            'platform': 'h5',
            'systemFrom': 'h5',
            'deviceId': sa.store.getDistinctId(),
            'anonymousId': sa.store.getDistinctId()
        }, data.param)
        data.param = JSON.stringify(p)
        //qs序列化数据 编码
        return new Promise((resolve, reject) => {
            axios[method](zaApi, qs.stringify(data)).then((response) => {
                resolve(response)
            }).catch((error) => {
                reject(error)
            })
        });
    },
    ddcms: (data) => {
        let method = data.method || 'post';
        //公共参数
        var p = Object.assign({}, {
            'partnerNo': 'NYDDXJD',
            'reqNo': randomString(20),
            'reqDate': getNow(),
            'apiVersion': '1.0.0',
        }, data.param)
        data.param = JSON.stringify(p)
        //qs序列化数据 编码
        return new Promise((resolve, reject) => {
            axios[method](cmsApi, qs.stringify(data)).then((response) => {
                resolve(response)
            }).catch((error) => {
                reject(error)
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/axios.js